/*--------------------------------------------------------------
# Custom scripts for Columns Slider Sidebar block
--------------------------------------------------------------*/

const sidebarCardsSlider = document.querySelectorAll('.sidebar-cards-slider .swiper');
const sidebarCardsSliderPagination = document.querySelectorAll('.sidebar-cards-swiper-pagination');
const sidebarCardsSliderNext = document.querySelectorAll('.sidebar-cards-swiper-next');
const sidebarCardsSliderPrev = document.querySelectorAll('.sidebar-cards-swiper-prev');

for (let i = 0; i < sidebarCardsSlider.length; i++) {
    // Loop through every example of the slider and add a dynamic class
    // then init slider, pagination, and nav arrows based on that new dynamic class
    sidebarCardsSlider[i].classList.add('swiper-' + i);
    sidebarCardsSliderPagination[i].classList.add('sidebar-cards-swiper-pagination-' + i);
    sidebarCardsSliderNext[i].classList.add('sidebar-cards-swiper-next-' + i);
    sidebarCardsSliderPrev[i].classList.add('sidebar-cards-swiper-prev-' + i);

    // Get the counter for each slider
    const activeCounter = document.querySelectorAll('.swiper-count--active strong')[i];
    const totalCounter = document.querySelectorAll('.swiper-count--total strong')[i]; // Get the total counter for each slider

    // Initialize the swiper
    var initSidebarCardsSlider = new Swiper('.sidebar-cards-slider .swiper-' + i, {
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 24,
        mousewheel: {
            enabled: true,
            releaseOnEdges: true,
            forceToAxis: true,
        },
        // Pagination toggle buttons
        pagination: {
            el: '.sidebar-cards-swiper-pagination-' + i,
            clickable: true,
        },
        // Navigation arrows
        navigation: {
            nextEl: '.sidebar-cards-swiper-next-' + i,
            prevEl: '.sidebar-cards-swiper-prev-' + i,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            748: {
                slidesPerView: 2.05,
                slidesPerGroup: 2,
            },
            992: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            1200: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            }
        },
        // on: {
        //     slideChange: function (swiper) {
        //         slide_change(swiper, activeCounter); // Pass swiper and its corresponding active counter
        //     }
        // }
    });

    // // Get the total number of slides
    // var totalSlides = sidebarCardsSlider[i].querySelectorAll('.swiper-slide').length;

    // // Update the total count for the slider
    // if (totalCounter) {
    //     totalCounter.textContent = totalSlides.toString().padStart(2, '0');
    // }

    // // Function to update the active slide number
    // function slide_change(swiper, counterElement) {
    //     var index = swiper.activeIndex + 1;
    //     // Update the specific counter for this slider
    //     counterElement.textContent = index.toString().padStart(2, '0');
    // }
}